import { format, getTime, formatDistanceToNow } from 'date-fns';
import moment from 'moment';

// ----------------------------------------------------------------------


export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'DD MMM YYYY h:mm a';

  // return date ? format(new Date(date), fm) : '';
  return moment(date).format(fm);
}

export function fDateTimeKE(date, newFormat) {
  const fm = newFormat || 'DD MMM YYYY h:mm a';
  moment.parseZone(date).format(fm);
  // return date ? format(new Date(date), fm) : '';
  // return moment_ke(date).tz('Africa/Nairobi').format(fm);
  return moment.parseZone(date).format(fm);
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}
